import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store/index'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import '@progress/kendo-theme-default/dist/all.css';
import {persister} from './store'
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate persistor={persister} loading={null}>
    <App />
    </PersistGate>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
